
export function getTopStoryIds(): Promise<number[]> {
    return fetch('https://hacker-news.firebaseio.com/v0/topstories.json', { credentials: "same-origin" })
        .then(resp => {
            if (!resp.ok) {
                return [];
            }
            return resp.json();
        })
        .catch(() => {
            return [];
        });
}
